import { render, staticRenderFns } from "./CompareLoansListSort.vue?vue&type=template&id=6567ffe4&scoped=true&"
import script from "./CompareLoansListSort.vue?vue&type=script&lang=js&"
export * from "./CompareLoansListSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6567ffe4",
  null
  
)

export default component.exports